// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/insegne/:id/codici-articolo',
    requestBody: null,
    response: '{"success":true,"data":[{"id":1,"codiceArticoloInsegna":"410007660","articoloId":48,"articolo":{"id":48,"codice":"XST-SCOLAC60","descrizioneBase":"...","ean":null,"marca":{"nome":"Smartix"}}}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/insegne/:id/articoli-smartix?q=',
    requestBody: null,
    response: '{"success":true,"data":[{"id":48,"codice":"XST-SCOLAC60","descrizioneBase":"...","ean":null}]}'
  },
  {
    method: 'POST',
    endpoint: '/api/anagrafiche/insegne/:id/codici-articolo',
    requestBody: '{"articoloId":48,"codiceArticoloInsegna":"410007660"}',
    response: '{"success":true,"data":{"id":1,"codiceArticoloInsegna":"410007660","articoloId":48,"articolo":{"id":48,"codice":"XST-SCOLAC60","descrizioneBase":"...","ean":null,"marca":{"nome":"Smartix"}}}}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/anagrafiche/insegne/:id/codici-articolo/:codiceId',
    requestBody: null,
    response: '{"success":true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
